import React from 'react';
import Reveal from '@/components/Reveal';

const SectionHeading = ({ eyebrow, title, sub, align = 'left', dark = false, number }) => (
  <Reveal className={`mb-10 md:mb-14 ${align === 'center' ? 'text-center' : ''}`}>
    {number && (
      <span className={`font-display text-6xl md:text-7xl font-medium leading-none ${dark ? 'text-ivory/10' : 'text-palm/10'}`}>{number}</span>
    )}
    <p className="text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase text-gold mt-2">{eyebrow}</p>
    <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight mt-3 leading-[1.1] ${dark ? 'text-ivory' : 'text-palm'}`}>{title}</h2>
    {sub && <p className={`mt-4 max-w-2xl text-sm sm:text-base leading-relaxed ${dark ? 'text-ivory/70' : 'text-muted-foreground'} ${align === 'center' ? 'mx-auto' : ''}`}>{sub}</p>}
  </Reveal>
);

export default SectionHeading;
